import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Navbar from "../../../Components/Common/navbar";
import { API, BACKEND_HOST } from "../../../api";
import { useAuthContext } from "../../../Components/AuthContext";
import MobileViewContainer from "../../../Components/MobileViewContainer";
import PromotionGiftLayout from "../components/PromotionGiftLayout";
import { mapCouponGiftItem } from "../components/promotionGiftMappers";
import {
  buildPromotionCouponSeoMeta,
  getInitialPromotionCouponData,
  PromotionSeoHelmet,
} from "../components/promotionSeo.jsx";

const PromotionB2BCouponPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { share_pin_code } = useParams();
  const { isUserLogin } = useAuthContext();
  const initialCouponItem = getInitialPromotionCouponData(share_pin_code);

  const [couponItem, setCouponItem] = useState(initialCouponItem);
  const [isLoading, setIsLoading] = useState(!initialCouponItem);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const fetchItem = ({ showLoading = true } = {}) => {
    if (showLoading) {
      setIsLoading(true);
    }

    setError(null);

    API.get(`${BACKEND_HOST}/coupon/stock/check/${share_pin_code}/`)
      .then((response) => response.data)
      .then((data) => {
        setCouponItem(data);
      })
      .catch((e) => {
        console.log(e);
        setError(e);
        setCouponItem((currentItem) => currentItem ?? null);
      })
      .finally(() => {
        if (showLoading) {
          setIsLoading(false);
        }
      });
  };

  useEffect(() => {
    const seededCouponItem = getInitialPromotionCouponData(share_pin_code);

    if (seededCouponItem) {
      setCouponItem(seededCouponItem);
      setIsLoading(false);
    } else {
      setCouponItem(null);
      setIsLoading(true);
    }
  }, [share_pin_code]);

  useEffect(() => {
    const seededCouponItem = getInitialPromotionCouponData(share_pin_code);
    fetchItem({ showLoading: !seededCouponItem });
  }, [isUserLogin, share_pin_code]);

  const handlePrimaryAction = () => {
    if (!isUserLogin) {
      navigate(`/login?path=${location.pathname}`);
      return;
    }

    if (!couponItem || couponItem?.remainings <= 0 || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    API.put(`/coupon/stock/receive/${share_pin_code}/`, {})
      .then(() => {
        toast.error("선물을 받았습니다.");
      })
      .catch((e) => {
        console.log(e);
        toast.error("선물을 받을 수 없습니다.");
      })
      .finally(() => {
        setIsSubmitting(false);
        fetchItem();
      });
  };

  const mappedItem = mapCouponGiftItem(couponItem);
  const isReceived = isUserLogin && mappedItem.remainingCount <= 0;
  const seoMeta = buildPromotionCouponSeoMeta({
    couponItem,
    sharePinCode: share_pin_code,
  });

  return (
    <>
      <PromotionSeoHelmet meta={seoMeta} />
      <MobileViewContainer>
        <Navbar />
        <PromotionGiftLayout
          {...mappedItem}
          isLoggedIn={isUserLogin}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          isReceived={isReceived}
          onPrimaryAction={handlePrimaryAction}
          error={error}
        />
      </MobileViewContainer>
    </>
  );
};

export default PromotionB2BCouponPage;
